const PERMISSION_KEY= "crm:company_report";
const PAGE_URL = {
    COMPANY_REPORT_PAGE: "/admin/crm/company-report"
}

export {PERMISSION_KEY, PAGE_URL}

